<template>
  <div class="base-custom-select relative"
       :cy="cy || name">
    <span v-if="!noLabel"
          class="block">
      {{ label || name }}
    </span>

    <input type="text"
           :value="value"
           @input="handleInput"
           @focus="handleFocus"
           @blur="handleBlur"
           :placeholder="placeholder" />

    <ul :class="{'visible': isFocus}">
      <li v-for="(item, index) in options"
          :key="index"
          @mousedown="handleSelect(item)">
        {{ item[optionKey] }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'BaseSelect',
    props: {
      name: String,
      label: String,
      cy: String,
      value: String,
      placeholder: String,
      optionKey: String,
      simple: Boolean,
      noLabel: Boolean,
      options: Array
    },
    data () {
      return {
        isFocus: false
      }
    },
    methods: {
      handleFocus () {
        this.isFocus = true;
      },
      handleBlur () {
        this.isFocus = false;
      },
      handleInput (ev) {
        const value = ev.currentTarget.value;
        this.$emit('search', {name: this.name, value});
      },
      handleSelect (value) {
        this.$emit('select', {name: this.name, value});
      }
    }
  }
</script>

<style lang="less">
  .base-custom-select {
    @media only screen and (min-width: 0) {
      > span {
        margin-bottom: 4px;
        font-size: 1.4rem;
      }
      input {
        width: 100%;
        padding-left: 8px;
      }
      ul {
        max-height: 180px;
        width: 100%;
        overflow-y: scroll;
        position: absolute;
        z-index: 999;
        left: 0;
        top: 54px;
        border-radius: 4px;
        background-color: white;
        border: 1px solid #c8c8c8;
        &:not(.visible) {
          display: none;
        }
        li {
          padding: 4px 0 4px 8px;
          font-size: 1.5rem;
          cursor: pointer;
        }
      }
    }
  }
</style>
